import picoApp from './pico-app';
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

console.log('💄 FINDING FERDINAND', isMobile);

function appHeight() {
  const doc = document.documentElement;
  doc.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
}

if (!isMobile) window.addEventListener('resize', appHeight);
appHeight();

picoApp.mount();
